module.exports = __webpack_public_path__ + "static/media/main-background.354f8747.png";